module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\"><path fill=\"#9B9B9B\" fill-rule=\"nonzero\" d=\"M4.06 8.54V4.2H1.4C.63 4.2 0 4.83 0 5.6v4.2c0 .77.63 1.4 1.4 1.4h.7v2.1l2.1-2.1h3.5c.77 0 1.4-.63 1.4-1.4V8.526a.66.66 0 0 1-.14.015h-4.9V8.54zM12.6.7H6.3c-.77 0-1.4.63-1.4 1.4v5.6h4.9l2.1 2.1V7.7h.7c.77 0 1.4-.63 1.4-1.4V2.1c0-.77-.63-1.4-1.4-1.4z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-chat.svg
// module id = 1974
// module chunks = 1